export const actionTypes = {
  RESET: 'PROPERTY_OBJECTS.EDITED_FORMULA_RESET',
  SET_EDITED_FORMULA_ID: 'PROPERTY_OBJECTS.FORMULA.SET_EDITED_FORMULA',
};

export function reset() {
  return {
    type: actionTypes.RESET,
  };
}

export function setEditedFormula(formulaId) {
  return {
    type: actionTypes.SET_EDITED_FORMULA_ID,
    payload: formulaId,
  };
}
